<template>
  <v-list-item
    v-ripple="{ class: 'text-primary' }"
    :href="href"
    :rel="href && href !== '#' ? 'noopener' : undefined"
    :target="href && href !== '#' ? '_blank' : undefined"
    v-bind="routeTo ? { to: routeTo } : {}"
    :active-class="` ${
      isDark ? ' text-blue text-grey-lighten-1' : 'text-primary'
    }`"
    class="base-item"
    :class="item.group ? `text-14 pl-2` : `text-18 pl-8`"
    @click="logClick">
    <template v-if="text" v-slot:prepend>
      <div class="v-list-item__icon--text">{{ computedText }}</div>
    </template>

    <template v-else-if="item.icon" v-slot:prepend>
      <v-icon v-text="item.icon" />
    </template>

    <template v-if="item.title || item.subtitle" #title>
      <span class="ma-0 pa-0 text-14 localFont">{{ item.title }}</span>
    </template>
  </v-list-item>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import pinia from '@/pinia'
import { useRequestStore } from '@/pinia/stores/requestStore'
import themeMixin from '@/mixin/themeMixin'

export default defineComponent({
  name: 'Item',
  mixins: [themeMixin],
  props: {
    alertProp: {
      type: Number,
      default: 0,
    },
    item: {
      type: Object,
      default: () => ({
        href: undefined,
        icon: undefined,
        subtitle: undefined,
        title: undefined,
        to: undefined,
      }),
    },
    text: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    requestStore() {
      return useRequestStore(pinia)
    },
    clusterRequestCount() {
      return this.requestStore.clusterRequestCount ?? 0
    },
    admissionRequestCount() {
      return this.requestStore.admissionRequestCount ?? 0
    },
    computedText() {
      if (!this.item || !this.item.title) return ''

      let text = ''

      this.item.title.split(' ').forEach((val) => {
        text += val.substring(0, 1)
      })

      return text
    },
    isDark() {
      return Boolean(this.themeMode?.isDark)
    },
    routeTo() {
      const to = this.item?.to
      if (!to) return null
      if (typeof to === 'string') {
        return to.startsWith('/') ? to : `/${to}`
      }
      if (typeof to === 'object') {
        if (typeof to.path === 'string' && to.path) {
          return {
            ...to,
            path: to.path.startsWith('/') ? to.path : `/${to.path}`,
          }
        }
        return to
      }
      return null
    },
    href() {
      return this.item.href || (!this.item.to ? '#' : undefined)
    },
  },
  methods: {
    logClick() {
      console.log('[base-item clicked]', {
        title: this.item.title,
        to: this.item.to,
        href: this.href,
        item: this.item
      })
    },
  },
})
</script>
